import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { RHeader, RPage, RViewer } from '../../../../components/PdfRender';
import { useCompany } from '../../../../hooks/company';
import { IFinancial } from '../../../interfaces';
import * as S from './styles';
import { currency } from '../../../utils/functions';
import { differenceInDays, formatDate } from '../../../utils/format-date';

interface IDelinquencyReportProps {
  financials: IFinancial[];
}

export const DelinquencyReport: React.FC<IDelinquencyReportProps> = ({
  financials,
}) => {
  const { company } = useCompany();
  const total = financials.reduce((acc, curr) => acc + Number(curr.value), 0);
  const today = new Date();

  return (
    <RViewer>
      <RPage size={'A4'}>
        <View style={S.styles.container}>
          <RHeader company={company} />
          <Text style={S.styles.title}>Relatório de Inadimplência</Text>

          <View style={S.styles.table}>
            <View style={[S.styles.tableRow, S.styles.tableHeader]}>
              <View style={[S.styles.tableCol, S.styles.colCode]}>
                <Text>Conta</Text>
              </View>
              <View style={[S.styles.tableCol, S.styles.colDate]}>
                <Text>Vencimento</Text>
              </View>
              <View style={[S.styles.tableCol, S.styles.colClient]}>
                <Text>Cliente</Text>
              </View>
              <View style={[S.styles.tableCol, S.styles.colPhone]}>
                <Text>Telefone</Text>
              </View>
              <View style={[S.styles.tableCol, S.styles.colDays]}>
                <Text>Dias</Text>
              </View>
              <View style={[S.styles.tableCol, S.styles.colValue]}>
                <Text>Valor</Text>
              </View>
            </View>

            {financials.map((item, index) => {
              const daysLate = differenceInDays(today, new Date(item.due_date));
              return (
                <View key={index} style={S.styles.tableRow}>
                  <View style={[S.styles.tableCol, S.styles.colCode]}>
                    <Text>{item.code}</Text>
                  </View>
                  <View style={[S.styles.tableCol, S.styles.colDate]}>
                    <Text>{formatDate(item.due_date)}</Text>
                  </View>
                  <View style={[S.styles.tableCol, S.styles.colClient]}>
                    <Text>{item.client_name}</Text>
                  </View>
                  <View style={[S.styles.tableCol, S.styles.colPhone]}>
                    <Text>{item.client_phone || '-'}</Text>
                  </View>
                  <View style={[S.styles.tableCol, S.styles.colDays]}>
                    <Text>{daysLate}</Text>
                  </View>
                  <View style={[S.styles.tableCol, S.styles.colValue]}>
                    <Text>{currency(item.value)}</Text>
                  </View>
                </View>
              );
            })}
          </View>

          <View style={S.styles.totalContainer}>
            <Text style={S.styles.totalText}>
              Total Inadimplente: {currency(total)}
            </Text>
          </View>
        </View>
      </RPage>
    </RViewer>
  );
};
